module.exports = __webpack_public_path__ + "img/ecosystem.7801ffa4.png";